module.exports = __webpack_public_path__ + "img/logo.334ccf73.png";